var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogisticsFilledV2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_48931_2085)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 5.58298C6.1258 5.36535 6.30661 5.18462 6.52431 5.05894L11.5414 2.19205C11.7593 2.06623 12.0065 2 12.2581 2C12.5097 2 12.7569 2.06623 12.9748 2.19205L17.9919 5.05894C18.2096 5.18462 18.3904 5.36535 18.5162 5.58298C18.642 5.80061 18.7083 6.04749 18.7086 6.29887V12.0326C18.7083 12.284 18.642 12.5309 18.5162 12.7485C18.3904 12.9662 18.2096 13.1469 17.9919 13.2726L12.9748 16.1395C12.7569 16.2653 12.5097 16.3315 12.2581 16.3315C12.0065 16.3315 11.7593 16.2653 11.5414 16.1395L9 14.6873",
    stroke: "white",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.71 6.29841C18.7097 6.04707 18.6444 5.80021 18.5204 5.5826C18.3965 5.36499 18.2184 5.18429 18.0039 5.05861L13.0611 2.19202C12.8464 2.06623 12.6029 2 12.355 2C12.1071 2 11.8636 2.06623 11.6489 2.19202L6.70611 5.05861C6.49164 5.18429 6.3135 5.36499 6.18956 5.5826C6.06563 5.80021 6.00025 6.04707 6 6.29841V12.0316C6.00025 12.2829 6.06563 12.5298 6.18956 12.7474C6.3135 12.965 6.49164 13.1457 6.70611 13.2714L11.6489 16.138C11.8636 16.2638 12.1071 16.33 12.355 16.33C12.6029 16.33 12.8464 16.2638 13.0611 16.138L18.0039 13.2714C18.2184 13.1457 18.3965 12.965 18.5204 12.7474C18.6444 12.5298 18.7097 12.2829 18.71 12.0316V6.29841Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5 5.28072C7.93511 6.68021 9.82291 7.76649 12.258 9.16598L19.0001 5.27344",
    stroke: "#3A3A40",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2578 17.0578V9.16602",
    stroke: "#3A3A40",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 12.1992L6 12.1992",
    stroke: "#3A3A40",
    strokeWidth: 3.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 9.19922H6",
    stroke: "#3A3A40",
    strokeWidth: 3.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 9.19922H6",
    stroke: "white",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 12.1992L6 12.1992",
    stroke: "white",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_48931_2085"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogisticsFilledV2);
export default __webpack_public_path__ + "static/media/logisticsFilledV2.491b41f99a83bc7b04a245db05d14bd5.svg";
export { ForwardRef as ReactComponent };